
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.054 2.658a3 3 0 013.892 0l.07.06a3 3 0 001.707.707l.092.008a3 3 0 012.752 2.752l.008.092a3 3 0 00.707 1.707l.06.07a3 3 0 010 3.892l-.06.07a3 3 0 00-.707 1.707l-.008.092A3 3 0 0117 16.218v4.938a1 1 0 01-1.287.958L12 21l-3.713 1.114A1 1 0 017 21.156v-4.938a3 3 0 01-1.567-2.402l-.008-.093a3 3 0 00-.707-1.707l-.06-.07a3 3 0 010-3.892l.06-.07a3 3 0 00.707-1.707l.008-.092a3 3 0 012.752-2.752l.092-.008a3 3 0 001.707-.707l.07-.06zM12.65 4.18l.07.06a5 5 0 002.845 1.179l.092.007a1 1 0 01.918.918l.007.092A5 5 0 0017.76 9.28l.06.07a1 1 0 010 1.298l-.06.07a5 5 0 00-1.179 2.845l-.007.092a1 1 0 01-.918.918l-.092.007a5 5 0 00-2.845 1.179l-.07.06a1 1 0 01-1.298 0l-.07-.06a5 5 0 00-2.845-1.179l-.092-.007a1 1 0 01-.918-.918l-.007-.092A5 5 0 006.24 10.72l-.06-.07a1 1 0 010-1.298l.06-.07A5 5 0 007.42 6.436l.007-.092a1 1 0 01.918-.918l.092-.007A5 5 0 0011.28 4.24l.07-.06a1 1 0 011.298 0z"}}),_c('circle',{attrs:{"cx":"12","cy":"10","r":"3"}})])
          )
        }
      }
    